
export function insertAtCursor(inputEl, currentValue, insertText) {
    if (!inputEl) return (currentValue || "") + insertText;

    const value = currentValue || "";
    const start = typeof inputEl.selectionStart === "number" ? inputEl.selectionStart : value.length;
    const end = typeof inputEl.selectionEnd === "number" ? inputEl.selectionEnd : value.length;

    return value.slice(0, start) + insertText + value.slice(end);
}